import request from "@/api/request";
import type { JslsPlatformCode } from "@/network/admin/instant-retail/NetworkProduct";

/** 与商品侧平台顺序一致：MT → ELE → JD → XCX */
const JSLS_PLATFORM_ORDER: JslsPlatformCode[] = ["MT", "ELE", "JD", "XCX"];
const JSLS_PLATFORM_CODE_SET = new Set<string>(JSLS_PLATFORM_ORDER);

/** 按固定顺序归一化已入驻平台，丢掉未知编码 */
export function normalizeJslsPlatformCodes(codes: unknown): JslsPlatformCode[] {
    if (!Array.isArray(codes)) {
        return [];
    }
    const picked = new Set<JslsPlatformCode>();
    codes.forEach((code) => {
        if (typeof code === "string" && JSLS_PLATFORM_CODE_SET.has(code)) {
            picked.add(code as JslsPlatformCode);
        }
    });
    return JSLS_PLATFORM_ORDER.filter((code) => picked.has(code));
}

/** 归一化即时零售权限编号 */
export function normalizeJslsAuth(codes: unknown): number[] {
    if (!Array.isArray(codes)) {
        return [];
    }
    return codes
        .map((code) => Number(code))
        .filter((code) => Number.isFinite(code));
}

/**
 * 即时零售 PC 用户信息（/v4/users/jsls/pc 返回的 data 结构）
 */
export interface JslsUserData {
    /** 当前用户的即时零售权限编号数组 */
    jslsAuth: number[];
    /** 当前门店 ID */
    shopId: number | null;
    /** 当前零售门店 ID */
    mtStoreId: number | null;
    /** 当前门店的平台编码，可包含 MT/ELE/JD/XCX */
    platforms: string[];
    /** 美团店铺编码，有值时返回 */
    appPoiCode?: string;
    /** 饿了么自定义店铺编码，有值时返回 */
    eleMgShopCode?: string;
    /** 京东外部店铺编码，有值时返回 */
    jdOutShopCode?: string;
    /** 小程序门店编码，有值时返回 */
    miniProgramStoreCode?: string;
}

/**
 * 查询即时零售 PC 用户信息统一响应结构
 */
export interface JslsUserResponse {
    code: number;
    message: string;
    success: boolean;
    data: JslsUserData;
}

/**
 * 查询即时零售 PC 用户信息
 * @returns 即时零售 PC 用户信息响应
 */
export function getJslsUserInfoApi(): Promise<JslsUserResponse> {
    return request({
        url: "/v4/users/jsls/pc",
        method: "get"
    });
}
